import { render } from "./range-slider.vue?vue&type=template&id=36a7739c&scoped=true&ts=true"
import script from "./range-slider.vue?vue&type=script&lang=ts"
export * from "./range-slider.vue?vue&type=script&lang=ts"

import "./range-slider.vue?vue&type=style&index=0&id=36a7739c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a7739c"]])

export default __exports__